import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { LayoutsComponent } from './layouts/layouts.component';

import { RouterModule } from '@angular/router';
import { LoginLayoutsComponent } from '../shared/layouts/login-layouts.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderNotificationComponent } from './order-notification/order-notification.component';

@NgModule({
  declarations: [
    SidebarComponent,
    NavbarComponent,
    LayoutsComponent,
    LoginLayoutsComponent,
    OrderNotificationComponent
  ],

  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [NavbarComponent, LayoutsComponent, SidebarComponent,LoginLayoutsComponent, RouterModule],
  providers: [],
})
export class SharedModule { }
